<template>
    <div class="running-late">
        <button
                v-if="state === 'pristine'"
                v-on:click="state = 'choosing'"
                class="btn btn-warning full-width">
            {{ 'I am running late' | trans }}
        </button>

        <template v-else-if="state === 'choosing'">
            <div class="alert alert-info">
                {{ 'How late will you be?' | trans }}
            </div>
            <div class="row">
                <div
                        v-for="minutes in delayChoices"
                        v-bind:key="minutes"
                        class="col-xs-4 running-late__choice">
                    <button
                            v-on:click="send(minutes)"
                            class="btn btn-warning full-width">
                        {{ minutes }} {{ 'min' | trans }}
                    </button>
                </div>
            </div>
            <button
                    v-on:click="state = 'pristine'"
                    class="btn">
                {{ 'Back' | trans }}
            </button>
        </template>

        <div
                v-else-if="state === 'sending'"
                class="alert alert-info">
            {{ 'Sending' | trans }}...
        </div>
        <div
                v-else-if="state === 'sent'"
                class="alert alert-success">
            {{ 'Thanks' | trans }} ! {{ 'We have told the customer.' | trans }}
        </div>
        <div
                v-if="errorMessage !== null"
                class="alert alert-danger">
            {{ 'Error' | trans }} - {{ errorMessage }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            job: Object,
            user: Object
        },
        data() {
            return {
                state: 'pristine',
                errorMessage: null,
                delayChoices: [15, 30, 45, 60, 90, 120],
            }
        },
        methods: {
            async send(delayMinutes) {
                this.state = 'sending';
                this.errorMessage = null;
                try {
                    await this.$api.job.markAsRunningLate(this.job.id, delayMinutes);
                }
                catch (error) {
                    if (this.$api.is401(error)) {
                        // in case of 401, just abort javascript execution
                        return;
                    }
                    if (this.$api.isNoConnectivity(error)) {
                        this.errorMessage = this.$options.filters.trans('No connection ?');
                    } else {
                        this.$bugsnagClient.notify(error);
                        this.errorMessage = this.$options.filters.trans('Unknown error');
                    }
                    this.state = 'choosing';
                    return;
                }
                this.state = 'sent';
                this.$emit('declared', {job: this.job, delayMinutes});
            },
        },
    }
</script>

<style scoped>
    .running-late {
        margin-bottom: 12px;
    }

    /*
        Bootstrap rows carry a -15px side margin, meant to be cancelled by the
        15px padding of a .col-* parent. Our parent is .padding-startquizz-buttons,
        which forces that padding down to 10px, so the default row sticks out by
        5px on each side and makes the whole screen scroll sideways on a 320px
        phone.

        Pull the margin back to exactly the 4px the choices use as padding. The
        outer edges then line up with the two arrival buttons above, and all six
        choices keep the same width.
    */
    .running-late .row {
        margin-left: -4px;
        margin-right: -4px;
    }

    .running-late__choice {
        padding: 4px;
    }
</style>
